﻿import { IContactPositionForList } from './contact-position-for-list';
import { IPhoneNumber } from './phone-number';

export interface IContactForList {
    id: number,
    isDeleted: boolean,
    entityType: number,
    entityTypeName: string,
    entityTypeId: number,
    entityName: string,
    // fullName: string,
    firstName: string,
    lastName: string,
    email: string,
    centerAlias: string,
    centerName: string,
    isMemberCenter: string,
    positions: IContactPositionForList[],
    phoneNumbers: IPhoneNumber[],
}
